import { render, staticRenderFns } from "./ResponsePreview.vue?vue&type=template&id=9a4d243c&"
import script from "./ResponsePreview.vue?vue&type=script&lang=js&"
export * from "./ResponsePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports